import axios from 'axios';
import { firebase_app } from '../../../../Config/Config';
import { getFunctionUrl } from '../../../../utils/apiHost';

const ALLOWED_FIELDS = new Set([
  'address', 'agent', 'carbrand', 'carcolor', 'carmodel', 'carplate', 'carserial',
  'city', 'contract', 'contractname', 'country', 'date', 'note', 'noteadmin',
  'postalcode', 'price', 'price30days', 'price7days', 'rule', 'state', 'status', 'time',
]);

export const sanitizeClientAdminTicketFields = fields => {
  if (!fields || typeof fields !== 'object' || Array.isArray(fields)) {
    throw new Error("Les champs de l'avis sont invalides.");
  }
  const sanitized = {};
  Object.entries(fields).forEach(([field, value]) => {
    if (!ALLOWED_FIELDS.has(field)) {
      throw new Error(`Le champ ${field} ne peut pas être modifié depuis ce formulaire.`);
    }
    sanitized[field] = value;
  });
  return sanitized;
};

export const saveAdminTicketUpdate = async (ticketId, fields, options = {}) => {
  const currentUser = firebase_app.auth().currentUser;
  if (!currentUser) {
    throw new Error("Vous devez être connecté pour modifier cet avis.");
  }
  const idToken = await currentUser.getIdToken(true);
  const response = await axios.patch(
    getFunctionUrl('admin-ticket-update'),
    {
      ticketId: String(ticketId || '').trim(),
      fields: sanitizeClientAdminTicketFields(fields),
      ...(options.manualPayment ? { manualPayment: options.manualPayment } : {}),
    },
    {
      headers: { Authorization: `Bearer ${idToken}` },
    }
  );
  const data = response.data || {};
  if (data.status !== 'success') {
    throw new Error(data.message || "La sauvegarde de l'avis a échoué.");
  }
  return data;
};

export const confirmAndSaveAdminTicket = async ({ confirm, save, onSuccess, onError }) => {
  const confirmation = await confirm();
  if (!confirmation || !confirmation.isConfirmed) return false;
  try {
    const result = await save();
    onSuccess(result);
    return true;
  } catch (error) {
    onError(error);
    return false;
  }
};
